import React from "react";
import { Grid } from "@mui/material";
import translations from "../../config/language";

const language = process.env.REACT_APP_LANGUAGE;

const AccessToFinance = ({ selectedFarmer }) => {
    return (
        <div className="user-profile">
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>
                    {translations[language].accessToFinance}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].loansFromGovernmentBank}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>800k</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].loansFromCommercialBank}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>3M</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].grantsFromINGOs}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>10M</Grid>
            </Grid>
            <Grid container>
                <Grid item lg={12} className="grid-item" style={{ fontWeight: 700, paddingLeft: "20px" }}>
                    {translations[language].emergencyContactDetails}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item lg={4} className="grid-item" style={{paddingLeft:"20px"}}>{translations[language].mobileNumber}</Grid>
                <Grid item lg={8} className="grid-item" style={{ fontWeight: 700 }}>+234 9876 5432</Grid>
            </Grid>
        </div>
    );
};

export default AccessToFinance;